<template>
  <Layout>
    <PageHeader :title="title"/>
    <!--    <PageHeader :title="title" :items="items" />-->


    <div class="row">
      <div class="col-lg-12">
        <div v-if="isLoading" :key="'loading_types_content'">
          <div class="row">
            <div class="offset-5 spinner-border text-primary" role="status">
              <span class="visually-hidden"></span>
<!--              <span class="visually-hidden">Загрузка...</span>-->
            </div>
          </div>
        </div>
        <div v-else :key="'loaded_types_content'">
          <div class="card">
            <div class="card-body">

              <div class="row">

                <div class="card col-lg-2">
                  <div class="row card-title">
                    <h4>Типы</h4>
                  </div>
                  <div class="row card-body mt-3 table table-hover">
                    <table style="cursor: pointer;">
                      <tbody>
                      <tr class="row table-info">
                        <td v-if="currentTypeCode === null" class="col-12 text-white bg-info">
                          Все
                        </td>
                        <td v-else class="col-12 text-primary" @click="selectAllTypes">
                          Все
                        </td>
                      </tr>
                      <tr v-for="item in typeList" :key="item.code" :value="item.code" class="row table-info">
                        <td v-if="currentTypeCode === item.code" class="col-12 text-white bg-info"
                            @click="setCurrentType(item)">
                          {{ item.name }}
                        </td>
                        <td v-else class="col-12 text-primary" @click="setCurrentType(item)">
                          {{ item.name }}
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </div>

                <div class="card col-lg-2">
                  <div class="row card-title">
                    <h4 class="col-6">
                      Модели
                    </h4>
                    <div v-if="currentTypeCode !== null" class="col-6">
                      <div class="d-grid">
                        <button type="button" class="btn btn-sm btn-success w-100" @click="showCreateUnitModelPopup"><i class="fas fa-plus"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="row card-body table table-hover mt-3">

                    <table style="cursor: pointer;" class="col-12">

                      <tbody>

                      <div v-if="currentTypeCode !== null">

                        <tr class="row table-info">
                          <td v-if="currentModelId === null" class="col-12 text-white bg-info">
                            Все
                          </td>
                          <td v-else class="col-12 text-primary" @click="selectAllModels">
                            Все
                          </td>
                        </tr>

                        <tr v-for="item in filteredModelList" :key="item.id" :value="item.id"
                            class="table-info row" @click="setCurrentModel(item.id)"
                        >
                          <div class="col-12">
                            <td :class="currentModelId === item.id ? 'row text-white bg-info': 'row text-primary'">
                              <div class="col-2">
                                {{ item.id }}
                              </div>
                              <dev class="col-10">
                                {{ item.code }}
                              </dev>
                            </td>
                          </div>
                        </tr>
                      </div>
                      </tbody>
                    </table>

                  </div>
                </div>

                <div class="card col-lg-8">
                  <div class="row card-title">
                    <h4 class="col-3">
                      Мат.единицы
                    </h4>
                    <div v-if="currentModelId !== null" class="offset-4 col-5">
                      <div class="d-grid">
                        <button class="btn btn-sm btn-success" @click="showCreateUnitPopup">
                          <i class="fas fa-plus"></i> Оприходовать
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row card-body mt-3">
                    <div class="col-12">

                      <div v-if="isUnitsLoading" class="row" :key="'loading_units_content'">
                        <div class="offset-5 spinner-border text-primary" role="status">
                          <span class="visually-hidden"></span>
<!--                          <span class="visually-hidden">Загрузка...</span>-->
                        </div>
                      </div>
<!--                      <div v-if="unitsData !== null">-->
                      <div v-else-if="unitsData !== null" :key="'loaded_units_content'">

                        <table style="cursor: pointer;" class="col-12 table table-hover">

                          <thead class="row">
                          <th class="col-2">Тип</th>
                          <th class="col-1">Модель</th>
                          <th class="col-1">ID</th>
                          <th class="col-1">Серийный номер</th>
                          <th class="col-2">Название</th>
                          <th class="col-1">№ Договора</th>
                          <th class="col-2">Держатель</th>
                          <th class="col-2">Объект</th>
                          </thead>

                          <tbody>
                          <tr v-for="item in filteredUnitList" :key="item.id" :value="item.id" class="row table-info">
                            <td class="col-2">{{ item.type.name }}</td>
                            <td class="col-1">{{ item.model.code }}</td>
                            <td class="col-1">{{ item.id }}</td>
                            <td class="col-1">{{ item.serial_number }}</td>
                            <td class="col-2">
                              <button type="button" class="btn-success" @click="showEditUnitPopup(item)">{{ item.name }}</button>
                            </td>
                            <td class="col-1">{{ item.contract_number }}</td>
                            <td v-if="item.holder_id === null " :key="'no_holder_btn'" class="col-2">
                              <button type="button" class="btn-success" @click="showIncomingExistedUnitPopup(item)">ОПРИХОДОВАТЬ</button>
                            </td>
                            <td v-else-if="item.holder_code === 'stockroom' " :key="'stockroom_title_btn'" class="col-2">
                              <button type="button" class="btn-outline-info" @click="showMoveToHolderPopup(item)">СКЛАД</button>
                            </td>
                            <td v-else :key="'other_title_btn'" class="col-2">
                              <button type="button" class="btn-info" @click="confirmMoveToStockroom(item)">
                                {{ item.holder_title.slice(0, 20) + '...'}}
                              </button>
                            </td>
                            <td v-if="item.geo_location_id === null " :key="'no_geo_location_btn'" class="col-2">
                              <button type="button" class="btn-success" @click="showGeoIncomingExistedUnitPopup(item)">ОПРИХОДОВАТЬ</button>
                            </td>
                            <td v-else-if="item.geo_location_code === 'stockroom' " :key="'geo_stockroom_title_btn'" class="col-2">
                              <button type="button" class="btn-outline-info" @click="showGeoMovementsPopup(item)">СКЛАД</button>
                            </td>
                            <!-- ИСПРАВЛЕНО: Клик по кнопке теперь вызывает showGeoReturnMovementsPopup(item) -->
                            <td v-else :key="'geo_other_title_btn'" class="col-2">
                              <button type="button" class="btn btn-sm btn-info" @click="showGeoReturnMovementsPopup(item)">
                                {{ item.geo_location_name ? item.geo_location_name.slice(0, 20) + '...' : 'ОБЪЕКТ' }}
                              </button>
                            </td>
                          </tr>
                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <popup
        :closeButton="createUnitModelPopup.closeButton"
        :actionButton="createUnitModelPopup.actionButton"
        :actionClass="createUnitModelPopup.actionClass"
        :show="createUnitModelPopup.show"
        @closePopup="closeCreateUnitModelPopup"
        @actionPopup="submitCreateUnitModel"
    >
      <div slot="header">Создание модели складских единиц</div>
      <div slot="body">
        <CreateUnitModel
            ref="myChildCreateUnitModel"
            @new-unit-model-created="eventNewUnitModelCreated"
        >
        </CreateUnitModel>
      </div>
    </popup>

    <popup
        :closeButton="createUnitPopup.closeButton"
        :actionButton="createUnitPopup.actionButton"
        :actionClass="createUnitPopup.actionClass"
        :show="createUnitPopup.show"
        @closePopup="closeCreateUnitPopup"
        @actionPopup="submitCreateUnit"
    >
      <div slot="header">Создание складской единицы</div>
      <div slot="body">
        <CreateUnit
            ref="myChildCreateUnit"
            @new-unit-created="eventNewUnitCreated"
        >
        </CreateUnit>
      </div>
    </popup>

    <popup
        :closeButton="editUnitPopup.closeButton"
        :actionButton="editUnitPopup.actionButton"
        :actionClass="editUnitPopup.actionClass"
        :show="editUnitPopup.show"
        @closePopup="closeEditUnitPopup"
        @actionPopup="submitEditUnit"
    >
      <div slot="header">Редактирование складской единицы</div>
      <div slot="body">
        <EditUnit
            ref="myChildEditUnit"
            @unit-edited="eventUnitEdited"
        >
        </EditUnit>
      </div>
    </popup>

    <popup
        :closeButton="incomingExistedUnitPopup.closeButton"
        :actionButton="incomingExistedUnitPopup.actionButton"
        :actionClass="incomingExistedUnitPopup.actionClass"
        :show="incomingExistedUnitPopup.show"
        @closePopup="closeIncomingExistedUnitPopup"
        @actionPopup="submitIncomingExistedUnit"
    >
      <div slot="header">Оприходование существующей мат. единицы</div>
      <div slot="body">
        <IncomingExistedCreateUnit
            ref="myChildIncomingExistedUnit"
            @existed-unit-incomed="eventExistedUnitIncomed"
        >
        </IncomingExistedCreateUnit>
      </div>
    </popup>

    <popup
        :closeButton="geoIncomingExistedUnitPopup.closeButton"
        :actionButton="geoIncomingExistedUnitPopup.actionButton"
        :actionClass="geoIncomingExistedUnitPopup.actionClass"
        :show="geoIncomingExistedUnitPopup.show"
        @closePopup="closeGeoIncomingExistedUnitPopup"
        @actionPopup="submitGeoIncomingExistedUnit"
    >
      <div slot="header">Оприходование существующей мат. единицы на территорию Склада</div>
      <div slot="body">
        <GeoIncomingExistedCreateUnit
            ref="myChildGeoIncomingExistedUnit"
            @existed-unit-geo-incomed="eventExistedUnitGeoIncomed"
        >
        </GeoIncomingExistedCreateUnit>
      </div>
    </popup>

    <popup
        :closeButton="holderSelectorPopup.closeButton"
        :show="holderSelectorPopup.show"
        @closePopup="closeHolderSelectorPopup"
        >
      <div slot="header">Передача мат. единицы {{currentUnit.name}} id={{currentUnit.id}} со склада Держателю</div>
      <div slot="body">
        <HolderSelector
            ref="myChildHolderSelector"
            @event-holder-selected="eventHolderSelected"
        >
        </HolderSelector>
      </div>
    </popup>

    <popup
        :closeButton="geoMovementsPopup.closeButton"
        :size = "'xl'"
        :show="geoMovementsPopup.show"
        @closePopup="closeGeoMovementsPopup"
        >
      <div slot="header">Перемещение мат. единицы {{currentUnit.name}} id={{currentUnit.id}} со склада на Объект</div>
      <div slot="body">
        <UnitGeoMovements
            ref="myChildUnitGeoMovements"
            @unit-geo-moved="getUnits"
            @event-holder-selected="eventObjectAcceptorSelected"
        >
        </UnitGeoMovements>
      </div>
    </popup>

    <!-- ДОБАВЛЕНО: Новый попап для просмотра истории и оформления возврата на склад -->
    <popup
        :closeButton="geoReturnMovementsPopup.closeButton"
        :size="'xl'"
        :show="geoReturnMovementsPopup.show"
        @closePopup="closeGeoReturnMovementsPopup"
    >
      <div slot="header">История перемещений единицы {{currentUnit.name}} id={{currentUnit.id}} (Возврат на Склад)</div>
      <div slot="body">
        <UnitGeoReturnMovements
            ref="myChildUnitGeoReturnMovements"
            @unit-geo-moved="getUnits"
        />
      </div>
    </popup>

  </Layout>
</template>


<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Popup from "@/components/Popup.vue";
import CopyArrayAndObject from "@/components/libraries/CopyArrayAndObject";

import CreateUnitModel from "@/components/management/stockroom/CreateUnitModel.vue";
import CreateUnit from "@/components/management/stockroom/CreateUnit.vue";
import EditUnit from "@/components/management/stockroom/EditUnit.vue";
import IncomingExistedCreateUnit from "@/components/management/stockroom/IncomingExistedUnit.vue";
import GeoIncomingExistedCreateUnit from "@/components/management/stockroom/GeoIncomingExistedUnit.vue";
import HolderSelector from "@/components/management/stockroom/HolderList.vue";
import UnitGeoMovements from "@/components/management/stockroom/UnitGeoMovements.vue";
// ДОБАВЛЕНО к остальным импортам компонентов
import UnitGeoReturnMovements from "@/components/management/stockroom/UnitGeoReturnMovements.vue";


const copyArrObj = new CopyArrayAndObject();

/**
 * Partners component
 */
export default {
  components: {
    UnitGeoMovements,
    UnitGeoReturnMovements,
    HolderSelector,
    IncomingExistedCreateUnit,
    GeoIncomingExistedCreateUnit,
    CreateUnit,
    EditUnit,
    Popup,
    CreateUnitModel,
    Layout,
    PageHeader,
  },
  data() {
    return {
      geoReturnMovementsPopup: {
        show: false,
        closeButton: this.$t ? this.$t('popularWords.close') : 'Закрыть'
      },
      title: 'Склад',
      targetObjectAcceptor: null,
      isLoading: true,
      isUnitsLoading: true,
      targetHolder: {
        id: null,
        title: null,
      },
      currentTypeCode: null,
      currentTypeName: null,
      currentModelId: null,
      currentUnit: {
        id: null,
        name: null
      },
      geoMovementsPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      holderSelectorPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      createUnitModelPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      geoIncomingExistedUnitPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: 'Поместить на территорию склада',
        actionClass: "btn-success"
      },
      incomingExistedUnitPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      createUnitPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      editUnitPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      fullData: [
        {
          name: null,
          code: null,
          description: null,
          models: [
            {
              id: null,
              type: null,
              code: null,
              name: null,
              description: null,
              lastMovement: {
                acceptor: {
                  partner: {
                    id: null,
                    full_name: null,
                    contract_number: null,
                  }
                }
              },
            }
          ]
        }
      ],
      modelsData: [
        {
          id: null,
          type: null,
          code: null,
          name: null,
          description: null,
        }
      ],
      unitsData: [
        {
          id: null,
          model_id: null,
          serial_number: null,
          name: null,
          description: null,
          closed_at: null,
          holder_title: null,
          contract_number: null,
          holder_id: null,
          holder_code: null,
          geo_location_id: null,
          geo_location_code: null,
          geo_location_name: null,
          type: {
            code: null,
            name: null,
          },
        }
      ]
    };
  },
  validations: {},
  computed: {
    // IncomingExistedUnit() {
    //   return IncomingExistedUnit
    // },
    // createUnitModel() {
    //   return createUnitModel
    // },
    typeList() {
      let result = [];
      for (const [key, item] of Object.entries(this.fullData)) {
        result.push({
          code: item.code,
          name: item.name,
        });
      }

      return result;
    },
    filteredModelList() {
      if (this.currentTypeCode === null) {
        return null;
      }

      return this.fullData[this.currentTypeCode].models;
    },
    filteredUnitList() {

      return this.unitsData ? this.unitsData : null;
    },
  },
  methods: {
    async getUnits() {
      let params = '';
      if (this.currentModelId !== null) {
        params += 'model_id=' + this.currentModelId;
      } else if (this.currentTypeCode !== null) {
        params += 'type_code=' + this.currentTypeCode;
      }

      let uri = `/v1/units/get-all`;
      if (params !== '') {
        uri += '?' + params;
      }

      axios
          .get(uri)
          .then(resp => {
            this.isUnitsLoading = false;
            this.unitsData = resp.data;
            this.$forceUpdate();
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
          .finally (
              resp => {
                this.isUnitsLoading = false;
                this.$forceUpdate();
              }
          );
    },
    getData() {
      let uri = `/v1/unit-types/get-all-with-models`;
      axios
          .get(uri)
          .then(resp => {
            this.fullData = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
          .finally(
              resp => {
                this.isLoading = false;
                this.$forceUpdate();
              }
          );
    },
    selectAllTypes() {
      this.currentTypeCode = null;
      this.currentModelId = null;
      this.isUnitsLoading = true;
      this.getUnits();
    },
    setCurrentType(item) {
      // Чтобы не было лишних реактивностей
      if (this.currentTypeCode !== item.code) {
        this.currentTypeCode = item.code;
        this.currentTypeName = item.name;
        this.currentModelId = null;
        this.isUnitsLoading = true;
        this.getUnits();
      }
    },
    selectAllModels() {
      this.currentModelId = null;
      this.isUnitsLoading = true;
      this.getUnits();
    },
    setCurrentModel(id) {
      this.currentModelId = id;
      this.isUnitsLoading = true;
      this.getUnits();
    },

    /**
     * Создание модели
     */
    showCreateUnitModelPopup() {
      this.$refs.myChildCreateUnitModel.modelData.type = this.currentTypeCode;
      this.createUnitModelPopup.show = true;
    },
    closeCreateUnitModelPopup() {
      this.createUnitModelPopup.show = false;
    },
    async eventNewUnitModelCreated(data) {
      this.createUnitModelPopup.show = false;
      await this.getData();
      this.setCurrentModel(data.id);
    },
    submitCreateUnitModel() {
      this.$refs.myChildCreateUnitModel.createNewUnitModel();
    },

    /**
     * Создание мат.единицы
     */
    showCreateUnitPopup() {
      let currentModel = this.fullData[this.currentTypeCode].models.filter(item =>
        item.id === this.currentModelId
      )[0];

      this.$refs.myChildCreateUnit.initData(this.fullData[this.currentTypeCode].name, currentModel);
      this.createUnitPopup.show = true;
    },
    closeCreateUnitPopup() {
      this.createUnitPopup.show = false;
    },
    async eventNewUnitCreated(data) {
      this.createUnitPopup.show = false;
      this.getData();
      await this.getUnits();
    },
    submitCreateUnit() {
      this.$refs.myChildCreateUnit.submitCreateUnit();
    },

    /**
     * Оприходование существующей мат. единицы
     */
    showIncomingExistedUnitPopup(unit) {
      this.$refs.myChildIncomingExistedUnit.unitData = unit;
      this.incomingExistedUnitPopup.show = true;
    },
    closeIncomingExistedUnitPopup() {
      this.incomingExistedUnitPopup.show = false;
    },
    async eventExistedUnitIncomed() {
      this.incomingExistedUnitPopup.show = false;
      await this.getUnits();
    },
    submitIncomingExistedUnit() {
      this.$refs.myChildIncomingExistedUnit.incomingExistedUnit()
    },

    /**
     * Оприходование на Объект-склад
     */
    showGeoIncomingExistedUnitPopup(unit) {
      this.$refs.myChildGeoIncomingExistedUnit.unitData = unit;
      this.geoIncomingExistedUnitPopup.show = true;
    },
    closeGeoIncomingExistedUnitPopup() {
      this.geoIncomingExistedUnitPopup.show = false;
    },
    async eventExistedUnitGeoIncomed() {
      this.geoIncomingExistedUnitPopup.show = false;
      await this.getUnits();
    },
    submitGeoIncomingExistedUnit() {
      this.$refs.myChildGeoIncomingExistedUnit.geoIncomingExistedUnit()
    },



    /**
     * Редактирование существующей мат. единицы
     */
    showEditUnitPopup(unit) {
      this.$refs.myChildEditUnit.getUnitData(unit.id);
      this.editUnitPopup.show = true;
    },
    closeEditUnitPopup() {
      this.editUnitPopup.show = false;
    },
    async eventUnitEdited() {
      this.editUnitPopup.show = false;
      await this.getUnits();
    },
    submitEditUnit() {
      this.$refs.myChildEditUnit.submitEditUnit();
    },

    /**
     * Перемещение единицы со склада держателю
     */
    showMoveToHolderPopup(item) {
      this.currentUnit = item;
      this.$refs.myChildHolderSelector.question = 'Выберете получателя мат.единицы'
      this.$refs.myChildHolderSelector.showHolders();
      // this.$refs.myChildHolderSelector.getHoldersData();
      this.holderSelectorPopup.show = true;
    },
    closeHolderSelectorPopup() {
      this.holderSelectorPopup.show = false;
    },
    eventHolderSelected(selectedHolder) {
      this.targetHolder = selectedHolder;
      if (confirm('Подтвердите перемещение мат.единицы "'
          + this.currentUnit.name + '" с id=' + this.currentUnit.id + ' держателю "' + this.targetHolder.title + '"')) {

        this.moveUnitToHolder(this.currentUnit.id, this.targetHolder.id);
      }
    },
    moveUnitToHolder(unit_id, acceptor_holder_id) {
      let formData = new FormData();
      formData.append('id', unit_id);
      formData.append('holder_id', acceptor_holder_id);

      axios
          .post(`/v1/units/move-to-holder`, formData)
          .then(resp => {
            this.getUnits();
            this.closeHolderSelectorPopup();
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },

    /**
     * Перемещение мат.единицы от Держателя на склад
     */
    confirmMoveToStockroom(item) {

      if (confirm('Подтвердите перемещение мат.единицы "'
          + item.name + '" с id=' + item.id + ' От держателя "' + item.holder_title + '" на склад')) {

        this.moveUnitToStockroom(item.id, item.holder_id);

      }
    },

    moveUnitToStockroom(unit_id, donor_holder_id) {
      let formData = new FormData();
      formData.append('id', unit_id);
      formData.append('holder_id', donor_holder_id);

      axios
          .post(`/v1/units/move-to-stockroom`, formData)
          .then(resp => {
            this.getUnits();
            this.closeHolderSelectorPopup();
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },

    /**
     *  Перемещение мат.единицы со Склада на Объект
     */
    showGeoMovementsPopup(item) {
      this.$refs.myChildUnitGeoMovements.getGeoMovementsData(item.id);
      this.currentUnit = item;
      this.geoMovementsPopup.show = true;
    },
    closeGeoMovementsPopup() {
      this.geoMovementsPopup.show = false;
    },
    // ДОБАВЛЕНО: Метод открытия попапа истории возвратов
    showGeoReturnMovementsPopup(item) {
      this.currentUnit = item;
      this.geoReturnMovementsPopup.show = true; // Открываем окно

      this.$nextTick(() => {
        // Ждем отрисовки DOM и безопасно запрашиваем историю перемещений
        if (this.$refs.myChildUnitGeoReturnMovements) {
          this.$refs.myChildUnitGeoReturnMovements.getGeoMovementsData(item.id);
        }
      });
    },

    // ДОБАВЛЕНО: Метод закрытия попапа возвратов
    closeGeoReturnMovementsPopup() {
      this.geoReturnMovementsPopup.show = false;
    },

    eventObjectAcceptorSelected(selectedObjectAcceptor) {
      this.targetObjectAcceptor = selectedObjectAcceptor;
    }
  },
  created() {
    this.getData();
    this.getUnits();
  }
};
</script>

<style scoped lang="scss">
.search {
  margin-right: 15px;
}
</style>
